const verdictColors = {
    'Pass': 'bg-green-100 text-green-800',
    'Fail': 'bg-red-100 text-red-800',
    'Incomplete': 'bg-yellow-100 text-yellow-800',
};

const VerdictBadge = ({ verdict }) => {
    if (!verdict) return null;
    const color = verdictColors[verdict] || 'bg-gray-100 text-gray-700';
    return <span className={`inline-block px-2.5 py-1 text-xs font-semibold rounded-full ${color}`}>{verdict}</span>;
};

// const fmt = (v) => {
//     if (v === null || v === undefined) return '—';
//     return typeof v === 'number' ? v.toLocaleString('en-GH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : v;
// };

const pct = (v) => {
    if (v === null || v === undefined || v === 0) return '—';
    return `${(v * 100).toFixed(1)}%`;
};

function EzRentChecksSection({ ezRentChecks, onChange, readOnly }) {
    const ez = ezRentChecks || {};

    const checks = [
        { key: 'tenancyAgreementVerified', label: 'Tenancy agreement verified' },
        { key: 'landlordBankVerified', label: 'Landlord bank account verified' },
        { key: 'disbursementDirectToLandlord', label: 'Disbursement direct to landlord' },
        { key: 'signedForwardPledge', label: 'Signed forward pledge' },
        { key: 'pilotSLAAcknowledged', label: 'Pilot SLA acknowledged' },
    ];

    const handleChange = (field, value) => {
        if (onChange) onChange('ezRentChecks', field, value);
    };

    return (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-y border-gray-200 rounded-t-lg">
                <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">ezRent Checks</h3>
                <VerdictBadge verdict={ez.rentToIncomeVerdict} />
            </div>

            {/* Checklist */}
            <div className="divide-y divide-gray-100">
                {checks.map(check => (
                    <div key={check.key} className="flex items-center justify-between px-4 py-2.5">
                        <span className="text-sm text-gray-600">{check.label}</span>
                        {readOnly ? (
                            <span className={`text-sm font-medium ${ez[check.key] === 'Yes' ? 'text-green-700' : ez[check.key] === 'No' ? 'text-red-600' : 'text-gray-400'}`}>
                                {ez[check.key] || '—'}
                            </span>
                        ) : (
                            <select value={ez[check.key] || ''} onChange={e => handleChange(check.key, e.target.value)}
                                className="rounded-lg border border-gray-200 px-2 py-1 text-sm focus:ring-1 focus:ring-[#1e3a6e]">
                                <option value="">—</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                                <option value="N/A">N/A</option>
                            </select>
                        )}
                    </div>
                ))}
            </div>

            {/* Rent-to-Income */}
            <div className="px-4 pt-4 pb-1 border-t border-gray-200">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Rent-to-Income Ratio</span>
            </div>
            <div className="grid grid-cols-2 gap-3 px-4 py-3">
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Annual Net Income (GHS)</label>
                    <input type="number" value={ez.annualNetIncome || ''} disabled={readOnly}
                        onChange={e => handleChange('annualNetIncome', parseFloat(e.target.value) || 0)}
                        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:ring-1 focus:ring-[#1e3a6e] focus:border-[#1e3a6e] disabled:bg-gray-50" />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Rent Advance (GHS)</label>
                    <input type="number" value={ez.rentAdvance || ''} disabled={readOnly}
                        onChange={e => handleChange('rentAdvance', parseFloat(e.target.value) || 0)}
                        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:ring-1 focus:ring-[#1e3a6e] focus:border-[#1e3a6e] disabled:bg-gray-50" />
                </div>
            </div>
            <div className="divide-y divide-gray-100 border-t border-gray-100">
                <div className={`flex items-center justify-between px-4 py-3 ${ez.rentToIncomeRatio > 0.4 ? 'bg-red-50' : ez.rentToIncomeRatio > 0 ? 'bg-green-50' : ''}`}>
                    <span className="text-sm font-medium text-gray-700">Rent-to-Income Ratio</span>
                    <div className="flex items-center gap-2">
                        <span className={`text-sm font-bold ${ez.rentToIncomeRatio > 0.4 ? 'text-red-700' : 'text-green-700'}`}>
                            {pct(ez.rentToIncomeRatio)}
                        </span>
                        <VerdictBadge verdict={ez.rentToIncomeVerdict} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EzRentChecksSection;
